var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPasswordIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6212_20523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8334 9.06654V7.99987C13.8334 7.71697 13.7211 7.44566 13.521 7.24562C13.321 7.04558 13.0497 6.9332 12.7668 6.9332H2.10011C1.81722 6.9332 1.54591 7.04558 1.34587 7.24562C1.14583 7.44566 1.03345 7.71697 1.03345 7.99987V14.3999C1.03345 14.6828 1.14583 14.9541 1.34587 15.1541C1.54591 15.3542 1.81722 15.4665 2.10011 15.4665H12.7668C13.0497 15.4665 13.321 15.3542 13.521 15.1541C13.7211 14.9541 13.8334 14.6828 13.8334 14.3999V13.3332M13.8334 9.06654H9.56678C9.00099 9.06654 8.45836 9.2913 8.05829 9.69138C7.65821 10.0915 7.43345 10.6341 7.43345 11.1999C7.43345 11.7657 7.65821 12.3083 8.05829 12.7084C8.45836 13.1084 9.00099 13.3332 9.56678 13.3332H13.8334M13.8334 9.06654C14.3992 9.06654 14.9419 9.2913 15.3419 9.69138C15.742 10.0915 15.9668 10.6341 15.9668 11.1999C15.9668 11.7657 15.742 12.3083 15.3419 12.7084C14.9419 13.1084 14.3992 13.3332 13.8334 13.3332M4.23345 6.9332V3.7332C4.23345 2.88451 4.57059 2.07058 5.17071 1.47046C5.77082 0.870345 6.58475 0.533203 7.43345 0.533203C8.28214 0.533203 9.09607 0.870345 9.69619 1.47046C10.2963 2.07058 10.6334 2.88451 10.6334 3.7332V6.9332M13.3001 11.1999H14.3668M11.1668 11.1999H12.2334M9.03345 11.1999H10.1001",
    stroke: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6212_20523"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordIcon);
export default __webpack_public_path__ + "static/media/PasswordIcon.ee382497.svg";
export { ForwardRef as ReactComponent };